import { apiClient, API_PRX } from '@indipia/shared';

export interface UploadedFile {
  fileMapId: number;
  fileId: number;
  filePath: string;
  originalFileName: string;
  mimeType: string;
}

export async function fetchImageBlobUrl(fileUrl: string): Promise<string> {
  let path = fileUrl.startsWith('http') ? new URL(fileUrl).pathname : fileUrl;
  // apiClient의 baseURL이 이미 `/api`를 포함하므로(client.ts), 백엔드가 `/api/...`로
  // 시작하는 절대 경로를 내려주면 그대로 넘겼을 때 `/api/api/...`로 중복된다.
  if (path.startsWith('/api/')) path = path.slice('/api'.length);
  const res = await apiClient.get(path, { responseType: 'blob' });
  return URL.createObjectURL(res.data as Blob);
}

export async function uploadFile(
  file: File,
  entityType: string,
  entityId?: number,
): Promise<UploadedFile> {
  const form = new FormData();
  form.append('file', file);
  form.append('sourceAgent', 'sv-member');
  form.append('entityType', entityType);
  if (entityId != null) form.append('entityId', String(entityId));

  const res = await apiClient.post(`${API_PRX.INDIPIA}/files/upload`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const d = res.data?.data as Record<string, unknown>;
  return {
    fileMapId:        d['fileMapId']        as number,
    fileId:           d['fileId']           as number,
    filePath:         d['filePath']         as string,
    originalFileName: d['originalFileName'] as string,
    mimeType:         d['mimeType']         as string,
  };
}

/**
 * 1:1 문의 첨부 이미지 업로드 — sv-support.
 * 물리 저장은 support 폴더에서 담당하고, 서빙 경로(/indipia/image/{fileId})는 그대로 유지된다.
 * X-User-Id 헤더는 게이트웨이가 주입하므로 FE에서 별도 세팅하지 않는다.
 */
export async function uploadSupportFile(file: File): Promise<{ fileMapId: number }> {
  const form = new FormData();
  form.append('file', file);

  const res = await apiClient.post(`${API_PRX.SUPPORT}/files/upload`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const d = res.data?.data as Record<string, unknown>;
  return {
    fileMapId: (d['fileMapId'] ?? d['file_map_id']) as number,
  };
}
